import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Home from './routes/index'
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </>
  )
}

export default App
